// in src/CookieConsentScan/ShowReport.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import config from 'react-global-configuration';
import AssessmentIcon from '@material-ui/icons/Assessment';

class ShowReport extends Component {

    handleClick = () => {

        const webUrl = config.get('app.web_url');
        const {record } = this.props;
        window.open(`${webUrl}/cookie-scanner-report/${record.originId}.pdf`, '_blank');
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <AssessmentIcon /> &nbsp; Show report
        </Button>;
    }
}

ShowReport.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(ShowReport);